import {SkeletonBlock} from '@aboutyou/ui-components';
import React from 'react';
import {PriceAndA2BWrapper} from './PriceAndAddToBasketQuickViewView';

export const PriceAndAddToBasketQuickViewLoading: React.FC<{
  className?: string;
}> = ({className}) => {
  return (
    <section className={className}>
      <PriceAndA2BWrapper>
        <SkeletonBlock
          $width="100%"
          $height="55px"
          disableSpaceBelow
          disableRoundedCorners
        />
      </PriceAndA2BWrapper>
    </section>
  );
};
